import { WorkflowTypes } from 'common/workflow'
import { HttpClient } from '../../common/HttpClient'
import { Environment } from '../../enviroment/AppSettings'
import { CancelResponse, IUpdateWorkflowProps, SignApplicationDTO, SignResponse } from './ApplicationServiceModels'

//#region SettingService Instance
let instance: ApplicationService
//#endregion


export class ApplicationService{
    private readonly _client: HttpClient;
    private readonly _cancelApplicationUrlPath = "/application/cancel"
    private readonly _signApplicationUrlPath = "/application/sign"
    private readonly _updateWorkflowUrlPath = "/workflow"
  
   constructor() {
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!")
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl)
   }

   public async cancelApplication() : Promise<CancelResponse>{
      return (await this._client.post<CancelResponse, {}>(
        this._cancelApplicationUrlPath,
        {},
        true
      )).data
   }

   public async signApplication(sign: SignApplicationDTO): Promise<SignResponse> {
      return (await this._client.post<SignResponse, SignApplicationDTO>(
         this._signApplicationUrlPath,
         sign,
         true
      )).data
   }

   public async updateWorkflow(newWorkflowType: number){
      const updateWorkflowData: IUpdateWorkflowProps = { workflowId: newWorkflowType }
      return await this._client.put<IUpdateWorkflowProps>(this._updateWorkflowUrlPath, updateWorkflowData, true)
   }
}

let applicationService = Object.freeze(new ApplicationService())//SINGLETON DESIGN PATTERN
export default applicationService;